// This file was overwritten because of differences in the web and native sdks
import * as LDClient from 'launchdarkly-js-client-sdk'

import Config from 'APP/Config'
import { logger } from 'APP/Lib/Datadog'

// TODO: DIA-40444, Rehydrate the store redux LD
class _LaunchDarkly {
  constructor() {}

  init() {
    const multiContexts = {
      kind: 'multi',
      user: {
        key: Config.LD_USER_KEY.web,
      },
    }
    this.ldClientInstance = LDClient.initialize(Config.LD_CLIENT_ID, multiContexts)
  }

  async waitForLDInitialization() {
    try {
      await this.ldClientInstance.waitUntilReady()
    } catch (err) {
      logger.error('Failed while waiting for LaunchDarkly initialization', {}, err)
    }
  }

  async identify(userId) {
    try {
      const multiContexts = {
        kind: 'multi',
        user: {
          key: Config.LD_USER_KEY.web,
        },
        member: {
          key: String(userId),
        },
      }
      await this.ldClientInstance.identify(multiContexts)
    } catch (err) {
      logger.error('Failed to identify LaunchDarkly user', { userId }, err)
    }
  }

  async boolVariation(key, defaultValue) {
    return await this.ldClientInstance.variation(key, defaultValue)
  }

  async jsonVariation(key, defaultValue) {
    return await this.ldClientInstance.variation(key, defaultValue)
  }

  async variation(key, defaultValue) {
    return await this.ldClientInstance.variation(key, defaultValue)
  }

  async on(event, callback) {
    return this.ldClientInstance.on(event, callback)
  }
}

export const ld = new _LaunchDarkly()
export const waitForLDInitialization = async () => {
  try {
    await ld.waitForLDInitialization()
  } catch (err) {
    logger.error('LaunchDarkly initialization wait failed', {}, err)
  }
}

export const initLD = async () => {
  ld.init()
  await waitForLDInitialization()
}

export const identifyLD = async (userId) => {
  try {
    await ld.identify(userId)
  } catch (err) {
    logger.error('Failed to identify LaunchDarkly user', { userId }, err)
  }
}

export const ldClient = ld
